<template>
  <b-modal
    id="promo-code-payment-methods"
    title="Cards"
    no-close-on-backdrop
    ok-only
    @ok="onSaveHandler"
  >

    <BFormCheckboxGroup
      v-model="selected"
      :options="PAYMENT_METHODS"
    />

  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BModal, BFormCheckboxGroup } from 'bootstrap-vue'

const PAYMENT_METHODS = [
  {
    text: 'Master Card',
    value: 'MASTER_CARD',
  },
  {
    text: 'Visa',
    value: 'VISA',
  },
]

export default {
  components: {
    BModal,
    BFormCheckboxGroup,
  },
  props: {
    cardType: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const selected = ref(props.cardType ? props.cardType.split(',') : [])

    const onSaveHandler = () => {
      const splitted = selected.value.toString()
      emit('card-selection', splitted)
    }
    return {
      PAYMENT_METHODS,
      onSaveHandler,
      selected,
    }
  },
}
</script>
